import i18n from 'i18n'
import * as React from "react"
import { useState, useEffect } from "react"
import { SelectSeeker } from "ui-seeker/core"
import { postSubmit, getSubmit } from "ui-seeker/utils"

import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectSiteLocation({...props}) {
    
    const methodSubmit = {
        'GET': getSubmit,
        'POST': postSubmit,
    }[props.method || 'POST']

    const myProps = {
        placeholder: i18n.t('common:filters.allSites'),
        icon: { icon: 'map-marker' },
        ...props
    }

    const [ajaxOptions, setOptions] = useState([])

    useEffect(() => {
        if (props.mainHotels !== '') {
            setOptions([])
            methodSubmit(props.urlAjax || COMPETITION_URL.SITES, {
                hotelID: [props.mainHotels],
                ...props.market && { market: props.market },
                ...props.userID && { userID: props.userID },
                ...props.extraParams && { ...props.extraParams },
            }).then(r => {
                const options = r
                setOptions(options)
                if (props.onAjax) props.onAjax(options)
            }).catch(() => {
                setOptions([{ value: "error", label: i18n.t('common:filters.errorSearchResults') }])
            })    
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(props.market), JSON.stringify(props.mainHotels)])

    return <SelectSeeker options={ajaxOptions} {...myProps} />
}